/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import {
  Box,
  Dialog,
  Divider,
  Checkbox,
  TextField,
  Typography,
  DialogActions,
  DialogContent,
  FormControlLabel,
  IconButton,
  Chip
} from '@mui/material';

import { API } from '../../../../api';
import { toast } from 'react-toastify';
import { LoadingButton } from '@mui/lab';
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from '@mui/material/InputAdornment';
import CloseIcon from '@mui/icons-material/Close';

import { useAppDispatch } from '../../../../redux/hooks';
import AppLoader from '../../../../components/AppLoader';
import { getUserDetails } from '../../../../utils/orgName';
import ChatAvatarComponent from '../chat/ChatAvatarComponent';
import { GroupBasedRoleFormatter } from '../../components/common';
import { matchesActions } from '../../../../redux/slices/getAllMatches/getAllMatchesSlice';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import MenteeProfileModal from './MentorDash/Components/MenteeProfileModal';

interface Mentor {
  mid: string;
  displayName: string;
  headshot: string;
  position?: string;
}

interface RecruitNewMentorModalProps {
  title?: string;
  open: boolean;
  onClose: () => void;
  mentorsList: Mentor[];
  onProfileClick: (mid: string) => void;
  onChatClick: (mentor: Mentor) => void;
  onCalendarClick: (mentor: Mentor) => void;
  objId: string;
  grpId: string;
  apiType?: any;
  isAssignPopup?: any;
  onSelect?: any;
  assigneeRole?: any;
  userId?: any;
  dataArray?: any[];
  setDataArray?: any;
  learningObjective?: any;
  origin?: string;
}

const RecruitNewMentor: React.FC<RecruitNewMentorModalProps> = (props) => {
  const {
    title,
    open,
    onClose,
    mentorsList,
    onProfileClick,
    onChatClick,
    onCalendarClick,
    objId,
    grpId,
    apiType,
    isAssignPopup,
    userId,
    assigneeRole,
    onSelect,
    dataArray,
    setDataArray,
    learningObjective,
    origin
  } = props;

  // --------------------------
  // MESMA LÓGICA ORIGINAL
  // --------------------------
  const [data, setData] = useState<any[]>(mentorsList || []);
  const [recommendedData, setRecommendedData] = useState<any[]>([]);
  const [suggestedData, setSuggestedData] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [selectedObjectives, setSelectedObjectives] = useState<Record<string, string[]>>({});
  const [searchValue, setSearchValue] = useState('');
  const [selectedFromSearch, setSelectedFromSearch] = useState(false);
  const [profileModalOpen, setProfileModalOpen] = useState(false);
  const [profileUser, setProfileUser] = useState<any>(null);
  const handleOpenProfile = (mentor: any) => {
    setProfileUser(mentor);
    setProfileModalOpen(true);
  };
  const handleCloseProfile = () => {
    setProfileModalOpen(false);
    setProfileUser(null);
  };

  console.log({ learningObjective });

  const dispatch = useAppDispatch();
  const { orgId } = getUserDetails();

  const mentorRoleText = GroupBasedRoleFormatter('mentor', 'Mentor').toLowerCase();
  const menteeRoleText = GroupBasedRoleFormatter('mentee', 'Mentee').toLowerCase();
  const mentorPlural = GroupBasedRoleFormatter('mentor', 'Mentors').toLowerCase();
  const menteePlural = GroupBasedRoleFormatter('mentee', 'Mentees').toLowerCase();

  const filterData = (data: any[], searchValue: string) =>
    data.filter((item) => item?.name?.toLowerCase().includes(searchValue.toLowerCase()));

  const filteredRecommended = filterData(recommendedData, searchValue);
  const filteredSuggested = filterData(suggestedData, searchValue);

  const getHeadingText = () => {
    if (isAssignPopup) return '';
    if (apiType === 'all') return 'Find a Mentor';
    if (apiType === 'mentee') return 'Find a Mentee';
    return 'Find a Mentor';
  };

  const getNoDataMessage = () =>
    isAssignPopup
      ? assigneeRole === 'Assign Mentor'
        ? `No relevant ${mentorPlural} available.`
        : `No relevant ${menteePlural} available.`
      : 'No relevant members available.';

  const initialMatchingFields = {
    gender: false,
    firstGenStudent: false,
    ethnicity: false,
    disability: false,
    hobbies: false,
    major: false,
    university: false,
    industry: false,
    title: false,
    topics: false,
    industries: false,
    objectives: true
  };

  // === GETTERS =========================================
  const getMentors = async () => {
    setLoading(true);
    try {
      let response;
      if (apiType === 'objective' && objId) {
        response = await API.getObjectiveMentors({ objId, grpId, orgId });
      } else if (apiType === 'mentee') {
        response = await API.getAllObjectiveMentees({ grpId, orgId });
      } else {
        response = await API.getAllObjectiveMentors({ orgId, grpId });
      }
      if (response?.status === 200) {
        setData(response?.data?.data);
      }
    } finally {
      setLoading(false);
    }
  };

  const getRecommendedMentors = async () => {
    setLoading(true);
    try {
      if (apiType === 'match') {
        const response = await API.getListToAssignMatch({
          orgId,
          userId,
          grpId,
          data: {
            assigneeRole: assigneeRole === 'Assign Mentor' ? 'Mentee' : 'Mentor',
            matchingFields: initialMatchingFields
          },
          isMatchingFields: true
        });

        if (response.status === 200) {
          const result = response?.data?.data;
          if (result?.recommendations || result?.suggestions) {
            const suggestions = (result.suggestions || []).filter((s: any) => s.matchedObjectives?.length > 0);
            setRecommendedData(result.recommendations || []);
            setSuggestedData(suggestions);
            setData([]);
          } else {
            setData(result || []);
            setRecommendedData([]);
            setSuggestedData([]);
          }
        }
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      setData([]);
      setRecommendedData([]);
      setSuggestedData([]);
      setSelectedIds([]);
      setSelectedObjectives({});
      if (apiType === 'match') getRecommendedMentors();
      else getMentors();
    } else {
      setLoading(true);
      setData(mentorsList || []);
      setRecommendedData([]);
      setSuggestedData([]);
    }
  }, [open]);

  const handleClose = () => {
    setData([]);
    setRecommendedData([]);
    setSuggestedData([]);
    setSelectedIds([]);
    setSelectedObjectives({});
    setSearchValue('');
    setSelectedFromSearch(false);
    setLoading(false);
    onClose();
  };

  const handleSearchChange = (e: any) => setSearchValue(e.target.value);

  const handleMemberSelect = (mentor: any) => {
    const id = assigneeRole === 'Assign Mentor' ? mentor.mentorId : mentor.menteeId;
    setSelectedIds((prev) => (prev.includes(id) ? prev.filter((p) => p !== id) : [...prev, id]));
  };

  const handleObjectiveSelect = (event: any, id: string, objectiveId: string, mentor: any) => {
    setSelectedObjectives((prev) => {
      const current = prev[id] || [];
      const newSelection = event.target.checked ? [...current, objectiveId] : current.filter((o) => o !== objectiveId);

      setSelectedIds((prevIds) => {
        if (newSelection.length > 0 && !prevIds.includes(id)) {
          return [...prevIds, id];
        } else if (newSelection.length === 0 && prevIds.includes(id)) {
          return prevIds.filter((p) => p !== id);
        }
        return prevIds;
      });

      return { ...prev, [id]: newSelection };
    });
  };

  const handleSelect = async () => {
    if (selectedIds.length === 0) {
      toast.error(`Please select at least one ${assigneeRole === 'Assign Mentor' ? mentorRoleText : menteeRoleText}`);
      return;
    }

    try {
      setLoading(true);

      const payload = selectedIds.map((id) => ({
        assigneeRole: assigneeRole === 'Assign Mentor' ? 'Mentee' : 'Mentor',
        mentorId: assigneeRole === 'Assign Mentor' ? id : userId,
        menteeId: assigneeRole === 'Assign Mentor' ? userId : id,
        objectiveIds: selectedFromSearch ? [] : selectedObjectives[id] || []
      }));

      const response = await API.assignAMatch({ orgId, grpId, data: payload });

      if (response?.status === 200) {
        toast.success(`${assigneeRole === 'Assign Mentor' ? mentorRoleText : menteeRoleText} assigned successfully`);

        const matchesData = Array.isArray(response.data?.data) ? response.data.data : [response.data?.data];

        if (matchesData.length > 0) {
          setDataArray((prev: any) => [...prev, ...matchesData]);

          matchesData.forEach((match: any) => {
            if (match.mentee?.userId && match.mentor?.userId) {
              dispatch(
                matchesActions.updateMenteesMentors({
                  menteeId: match.mentee.userId,
                  mentorId: match.mentor.userId
                })
              );
            }
          });
        }

        onClose();
        if (onSelect) onSelect(selectedIds);
      }
    } finally {
      setLoading(false);
    }
  };

  const combinedRecommended = filteredRecommended.length ? filteredRecommended : [];
  const combinedSuggested = filteredSuggested.length ? filteredSuggested : [];
  const combinedList = () => {
    let list =
      combinedRecommended.length || combinedSuggested.length
        ? [...combinedRecommended, ...combinedSuggested]
        : data || [];
    if (learningObjective) {
      return list.filter((item) => item.matchedObjectives?.some((obj: any) => obj.id === learningObjective.id));
    } else return list;
  };

  const getObjectiveTitle = () =>
    combinedList()[0]?.matchedObjectives?.[0]?.name ||
    combinedList()[0]?.objectives?.[0]?.name ||
    combinedList()[0]?.objective ||
    combinedList()[0]?.objectiveName ||
    'Learning Objective';

  // ======================================================================
  //                     UI — F I G M A   R E P L I C A T E D
  // ======================================================================

  const renderObjectiveChips = (mentor: any) => {
    const objectives = mentor?.matchedObjectives || mentor?.objectives || [];
    if (!objectives.length) return null;

    const checkboxId = assigneeRole === 'Assign Mentor' ? mentor.mentorId : mentor.menteeId;

    return (
      <Box
        sx={{
          pl: '60px !important',
          display: 'flex',
          flexWrap: 'wrap',
          gap: '5px',
          mt: '4px'
        }}
      >
        {objectives.map((obj: any, idx: number) =>
          isAssignPopup ? (
            <FormControlLabel
              key={idx}
              control={
                <Checkbox
                  checked={selectedObjectives[checkboxId]?.includes(obj.id) || false}
                  onChange={(e) => handleObjectiveSelect(e, checkboxId, obj.id, mentor)}
                  sx={{
                    color: '#FDFDFD !important'
                  }}
                />
              }
              label={
                <Typography
                  sx={{
                    fontSize: '12px !important',
                    color: '#FDFDFD !important'
                  }}
                >
                  {obj.name}
                </Typography>
              }
              sx={{
                border: '1px solid #444444 !important',
                borderRadius: '20px !important',
                px: '8px !important',
                py: '2px !important',
                m: '0 !important'
              }}
            />
          ) : (
            <Chip
              key={idx}
              label={obj.name}
              sx={{
                border: '1px solid #444444 !important',
                borderRadius: '20px !important',
                background: 'transparent !important',
                color: '#FDFDFD !important',
                fontSize: '12px !important',
                height: '26px !important'
              }}
            />
          )
        )}
      </Box>
    );
  };

  const renderObjectiveCheckbox = (mentor: any) => {
    const objectives = mentor?.matchedObjectives || mentor?.objectives || [];
    if (!objectives.length) return null;

    const checkboxId = assigneeRole === 'Assign Mentor' ? mentor.mentorId : mentor.menteeId;

    return (
      <div
        style={{
          marginLeft: '60px'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '5px',
            mt: '4px'
          }}
        >
          {objectives.map((obj: any, idx: number) =>
            isAssignPopup ? (
              <FormControlLabel
                key={idx}
                control={
                  <Checkbox
                    checked={selectedObjectives[checkboxId]?.includes(obj.id) || false}
                    onChange={(e) => handleObjectiveSelect(e, checkboxId, obj.id, mentor)}
                    sx={{
                      color: '#FDFDFD !important'
                    }}
                  />
                }
                label={
                  <Typography
                    sx={{
                      fontSize: '12px !important',
                      color: '#FDFDFD !important'
                    }}
                  >
                    {obj.name}
                  </Typography>
                }
                // sx={{
                //   border: '1px solid #444444 !important',
                //   borderRadius: '20px !important',
                //   px: '8px !important',
                //   py: '2px !important',
                //   m: '0 !important'
                // }}
              />
            ) : (
              <Chip
                key={idx}
                label={obj.name}
                sx={{
                  border: '1px solid #444444 !important',
                  borderRadius: '20px !important',
                  background: 'transparent !important',
                  color: '#FDFDFD !important',
                  fontSize: '12px !important',
                  height: '26px !important'
                }}
              />
            )
          )}
        </Box>
      </div>
    );
  };

  const renderMentorRow = (mentor: any, index: number) => {
    const id = assigneeRole === 'Assign Mentor' ? mentor.mentorId : mentor.menteeId;

    const isSelected = selectedIds.includes(id);
    const avatar = mentor?.image || mentor?.headshot;
    const name = mentor?.name || mentor?.displayName || 'Mentor';
    const titleText = mentor?.title || mentor?.position || mentor?.headline || mentor?.role || '';

    return (
      <Box key={index} sx={{ width: '100%' }}>
        {index > 0 && <Divider sx={{ borderColor: '#2A2A2A !important', my: '20px' }} />}

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            {/* Avatar + info */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1 }}>
              <Box onClick={() => onProfileClick(mentor?.userId || mentor?.mid || '')} sx={{ cursor: 'pointer' }}>
                <ChatAvatarComponent
                  width="50px"
                  height="50px"
                  type="noStatus"
                  image={avatar}
                  firstLetter={name.slice(0, 1)}
                />
              </Box>

              <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <Typography
                  sx={{
                    fontSize: '16px !important',
                    fontWeight: '700 !important',
                    color: '#FDFDFD !important'
                  }}
                >
                  {name}
                </Typography>
                {titleText && (
                  <Typography
                    sx={{
                      fontSize: '12px !important',
                      color: '#B6B6B6 !important',
                      fontWeight: '500 !important'
                    }}
                  >
                    {titleText}
                  </Typography>
                )}
              </Box>
            </Box>

            {/* Right buttons */}
            {isAssignPopup ? (
              <div>
                <IconButton
                  onClick={() => handleOpenProfile(mentor)}
                  sx={{
                    width: '40px !important',
                    height: '40px !important',
                    background: '#CDCDCD !important',
                    borderRadius: '999px !important',
                    border: '1px solid #2A2A2A !important'
                  }}
                >
                  <AccountCircleOutlinedIcon sx={{ color: 'black' }} />
                </IconButton>
                <Checkbox
                  checked={isSelected}
                  onChange={() => handleMemberSelect(mentor)}
                  sx={{ color: '#FDFDFD !important', display: 'none' }}
                />
              </div>
            ) : (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                <IconButton
                  onClick={() => onChatClick(mentor)}
                  sx={{
                    width: '40px !important',
                    height: '40px !important',
                    background: 'linear-gradient(180deg, #F79420 0%, #F15A26 100%) !important',
                    borderRadius: '999px !important'
                  }}
                >
                  <QuestionAnswerIcon sx={{ color: 'white' }} />
                </IconButton>

                <IconButton
                  onClick={() => handleOpenProfile(mentor)}
                  sx={{
                    width: '40px !important',
                    height: '40px !important',
                    background: '#CDCDCD !important',
                    borderRadius: '999px !important',
                    border: '1px solid #2A2A2A !important'
                  }}
                >
                  <AccountCircleOutlinedIcon sx={{ color: 'black' }} />
                </IconButton>
              </Box>
            )}
          </Box>

          {origin !== 'admin' ? renderObjectiveChips(mentor) : renderObjectiveCheckbox(mentor)}
          {/* {renderObjectiveChips(mentor)} */}
        </Box>
      </Box>
    );
  };

  return (
    <>
      <Dialog
        fullWidth
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: '550px !important',
            maxWidth: '550px !important',
            background: '#0F0F0F !important',
            borderRadius: '8px !important',
            outline: '1px solid #444444 !important',
            outlineOffset: '-1px !important',
            overflow: 'hidden !important'
          }
        }}
      >
        {/* HEADER */}
        <Box
          sx={{
            width: '100%',
            px: '25px !important',
            py: '20px !important',
            display: 'flex',
            alignItems: 'center',
            borderBottom: '1px solid #2A2A2A !important',
            position: 'relative'
          }}
        >
          <Typography
            sx={{
              flex: 1,
              color: '#FDFDFD !important',
              fontSize: '18px !important',
              fontWeight: '700 !important'
            }}
          >
            {origin === 'admin' ? 'Assign Match(es)' : getHeadingText()}
          </Typography>

          {/* Close icon */}
          <IconButton
            onClick={handleClose}
            sx={{
              width: '22px !important',
              height: '22px !important',
              padding: '6px !important',
              position: 'absolute',
              right: '25px',
              top: '20px'
            }}
          >
            <CloseIcon sx={{color: 'white'}}/>
          </IconButton>
        </Box>

        {/* CONTENT */}
        <DialogContent
          sx={{
            p: '25px !important',
            display: 'flex',
            flexDirection: 'column',
            gap: '30px'
          }}
        >
          {/* TITLE BLOCK */}
          {origin !== 'admin' && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
              <Typography
                sx={{
                  fontSize: '14px !important',
                  color: '#FDFDFD !important',
                  fontWeight: '400 !important'
                }}
              >
                Learning Objective
              </Typography>

              <Typography
                sx={{
                  fontSize: '16px !important',
                  color: '#F79420 !important',
                  fontWeight: '700 !important',
                  textTransform: 'capitalize'
                }}
              >
                {learningObjective?.objective ?? getObjectiveTitle()}
              </Typography>
            </Box>
          )}

          {/* SEARCH (only Assign Popup) */}
          {/* {isAssignPopup && (
          <TextField
            fullWidth
            placeholder={`Search ${assigneeRole === 'Assign Mentor' ? mentorRoleText : menteeRoleText}...`}
            value={searchValue}
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ color: '#FDFDFD !important' }} />
                </InputAdornment>
              )
            }}
            sx={{
              background: '#1C1C1C !important',
              borderRadius: '6px !important',
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: '#444444 !important'
                }
              }
            }}
          />
        )} */}

          {/* LIST TITLE */}
          {origin !== 'admin' && (
            <Typography
              sx={{
                fontSize: '14px !important',
                fontWeight: '700 !important',
                color: '#FDFDFD !important'
              }}
            >
              People that can help to your objective:
            </Typography>
          )}

          {/* LIST */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            {loading ? (
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  height: '160px'
                }}
              >
                <AppLoader />
              </Box>
            ) : combinedList().length > 0 ? (
              combinedList().map((mentor, index) => renderMentorRow(mentor, index))
            ) : (
              <Typography
                sx={{
                  textAlign: 'center',
                  color: '#B6B6B6 !important',
                  py: '20px'
                }}
              >
                {getNoDataMessage()}
              </Typography>
            )}
          </Box>
        </DialogContent>

        {/* FOOTER */}
        {isAssignPopup && (
          <DialogActions sx={{ p: '20px !important' }}>
            <LoadingButton
              onClick={handleSelect}
              variant="contained"
              fullWidth
              loading={loading}
              disabled={selectedIds.length === 0}
              sx={{
                height: '48px !important',
                borderRadius: '6px !important',
                background: 'linear-gradient(180deg, #F79420 0%, #F15A26 100%) !important',
                textTransform: 'none !important',
                fontSize: '14px !important',
                fontWeight: '700 !important',
                color: 'white !important'
              }}
            >
              {origin === 'admin' ? 'Assign Match(es)' : 'Select'}
            </LoadingButton>
          </DialogActions>
        )}
      </Dialog>
      <MenteeProfileModal open={profileModalOpen} onClose={handleCloseProfile} user={profileUser || {}} />
    </>
  );
};

export default RecruitNewMentor;
